import classNames from 'classnames';
import React, { useState } from 'react';
import Button from './Button';
import Caret from './Caret';
import FloatingCard from './FloatingCard';
import Popover from './Popover';
import * as styles from './UnsplashColorPicker.module.scss';
import type { SupportedColorId } from './UnsplashColors';
import UnsplashColors, { UnsplashColor } from './UnsplashColors';

interface UnsplashColorPickerProps {
  value: SupportedColorId | null;
  onChange: (value: SupportedColorId | null) => void;
}

const UnsplashColorPicker = ({ value, onChange }: UnsplashColorPickerProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover
      open={isOpen}
      onOpenChange={setIsOpen}
      placement="bottom-start"
      view={
        <FloatingCard noArrow>
          <div className={styles.popover}>
            <div className={styles.label}>Filter by color</div>
            <UnsplashColors
              onSelect={(newValue) => {
                onChange(newValue);
                setIsOpen(false);
              }}
              value={value}
            />
          </div>
        </FloatingCard>
      }
    >
      <Button
        className={classNames(styles.picker, { [styles.isOpen]: isOpen })}
      >
        <UnsplashColor color={value} />
        <Caret direction={isOpen ? 'up' : 'down'} size={12} />
      </Button>
    </Popover>
  );
};

export default UnsplashColorPicker;
